import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/index.js';
import * as Sentry from '@sentry/react';
import { sentryConfig } from './config/sentry.js';

// Only initialize Sentry in production and staging environments
const shouldInitializeSentry = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isDevelopment = import.meta.env.DEV;

  return !isLocalhost && !isDevelopment;
};

if (shouldInitializeSentry()) {
  Sentry.init({
    ...sentryConfig,
    integrations: [
      Sentry.browserTracingIntegration(sentryConfig.integrations[0].options),
      Sentry.replayIntegration(sentryConfig.integrations[1].options),
    ],
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);
